import React from "react";
import { FaInstagram, FaWhatsapp } from "react-icons/fa";
import { Link } from "react-router-dom";

// mostrarInstagram={false}: las páginas de asociación solo muestran el ícono de WhatsApp
export const CustomFooter = ({ mostrarInstagram = true }) => {
  return (
    <div
      className="footer"
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        borderTop: "3px solid #D7192E",
        backgroundColor: "#10263A",
      }}
    >
      <div
        className="footerCuerpo"
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr 1fr",
          alignItems: "center",
          width: "100%",
          maxWidth: 1280,
          margin: "0 auto",
          padding: "28px min(4%, 51.2px) 28px min(2.6%, 33.3px)",
        }}
      >
        {/* Columna 1: Logo */}
        <div className="footerCol" style={{ display: "flex", justifyContent: "flex-start" }}>
          <img
            src="/img/logo-mundo-piloto.png"
            alt="Mundo Piloto"
            style={{ width: "clamp(150px, 21vw, 300px)", height: "auto", objectFit: "contain" }}
          />
        </div>

        {/* Columna 2: Redes sociales */}
        <div className="footerCol" style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 14 }}>
          {mostrarInstagram && (
            <a
              href="https://www.instagram.com/mundo.piloto/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <FaInstagram className="iconos-footer" style={{ color: "#10263A" }} />
            </a>
          )}
          <a
            href="https://wa.me/5492396416909"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="WhatsApp"
          >
            <FaWhatsapp className="iconos-footer" style={{ color: "#10263A" }} />
          </a>
        </div>

        {/* Columna 3: Enlaces */}
        <div
          className="footerCol footerLinks"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifySelf: "end",
            gap: 4,
            color: "#fff",
            fontSize: "0.95rem",
          }}
        >
          <Link to="/">Home</Link>
          <Link to="/login">Acceso Interno</Link>
          <a href="/terminos-y-condiciones" target="_blank" rel="noopener noreferrer">
            Términos y Condiciones
          </a>
          <a href="/politicas-de-privacidad" target="_blank" rel="noopener noreferrer">
            Privacidad
          </a>
        </div>
      </div>

      <div style={{ display: "flex", justifyContent: "center", backgroundColor: "#D7192E" }}>
        <a
          href="https://fasecuatro.com.ar/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#fff", padding: "0.6em", textDecoration: "underline" }}
        >
          Diseñado y Desarrollado por Fase Cuatro SAS
        </a>
      </div>
    </div>
  );
};
